import styled from '@emotion/styled'
import { Button as AntdButton } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import { CSSProperties, ReactNode } from 'react'
import color from '../../constant/colors'
import Image from './Image'
import Text from './Text'

const CustomStyledAntdButton = styled(AntdButton) <{
  background: string
  bordercolor: string
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 8px;

  color: ${({ color }) => color};
  background: ${({ background }) => background};
  width: 100%;
  max-width: 364px;
  height: 45px;
  border-radius: 8px;
  border-color: ${({ bordercolor }) => bordercolor};

  :hover,
  :active,
  :focus {
    background: ${({ background }) => background};
    background: #c1c1c1;
  }

  :disabled {
    background: #c1c1c1;

    :hover,
    :focus,
    :active {
      background: #c1c1c1;
    }
  }
`
type CustomButtonProps = {
  children: ReactNode
  style?: CSSProperties
  background?: string
  borderColor?: string
  fontColor?: string
  textProps?: {}
  iconImage?: string
  id?: string
} & Pick<
  ButtonProps,
  | 'block'
  | 'danger'
  | 'disabled'
  | 'ghost'
  | 'href'
  | 'htmlType'
  | 'icon'
  | 'loading'
  | 'shape'
  | 'size'
  | 'target'
  | 'type'
  | 'onClick'
>
const OutlineButton = (props: CustomButtonProps) => {
  const {
    id,
    children,
    style,
    onClick,
    disabled = false,
    textProps,
    iconImage,
    borderColor = color.CHOICES_PRIMARY,
    fontColor = color.CHOICES_PRIMARY,
    ...resProps
  } = props
  const backgroundColor = color.WHITE

  return (
    <CustomStyledAntdButton
      disabled={disabled}
      onClick={onClick}
      background={backgroundColor}
      bordercolor={borderColor}
      style={style}
      id={id}
      {...resProps}
    >
      {iconImage ? <Image src={iconImage} style={{ marginRight: 8 }} /> : null}
      <Text size={14} type="Bold" color={disabled ? backgroundColor : fontColor} {...textProps}>
        {children}
      </Text>
    </CustomStyledAntdButton>
  )
}

export default OutlineButton
